import { useOpenReferenceMaterial } from 'core/hooks/useOpenReferenceMaterial';
import { useTranslation } from 'react-i18next';
import { hasRenderableHtml } from 'core/utils/utils';
import type { AttachmentContent } from 'app/types/attachment';

type UseMaterialPreviewStudentSidebarProps = {
  courseGuid?: string;
  description?: string;
  referenceMaterial?: AttachmentContent | null;
  attachedFiles?: { name: string; size: number; type: string; url: string }[];
};

type UseMaterialPreviewStudentSidebarReturn = {
  t: (key: string, options?: Record<string, unknown>) => string;
  hasAttachments: boolean;
  handleShowVisor: () => void;
  description: string;
};

function useMaterialPreviewStudentSidebar({
  courseGuid,
  description,
  referenceMaterial,
  attachedFiles = [],
}: UseMaterialPreviewStudentSidebarProps): UseMaterialPreviewStudentSidebarReturn {
  const { t } = useTranslation(['actions', 'common']);
  const openReferenceMaterial = useOpenReferenceMaterial(courseGuid);

  const hasAttachments = !!(referenceMaterial || attachedFiles.length > 0);
  // Se normaliza aquí a cadena vacía (misma convención que `useLessonViewPowerContentStudent`)
  // para que el componente decida con un solo valor y no con dos que hay que recordar cruzar.
  const renderableDescription = hasRenderableHtml(description) ? (description ?? '') : '';

  function handleShowVisor() {
    if (referenceMaterial) openReferenceMaterial(referenceMaterial);
  }

  return { t, hasAttachments, handleShowVisor, description: renderableDescription };
}

export default useMaterialPreviewStudentSidebar;
